import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../api';

function clp(n) {
  return `$${Number(n || 0).toLocaleString('es-CL')}`;
}

function isoDate(d) {
  return d.toISOString().slice(0, 10);
}

export default function FlujoCajaPage() {
  const { cid } = useParams();
  const now = new Date();
  const inicio = new Date(now.getFullYear(), now.getMonth(), 1);
  const [desde, setDesde] = useState(isoDate(inicio));
  const [hasta, setHasta] = useState(isoDate(now));
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  const load = () => {
    setError('');
    api
      .get(`/gastos-comunes/condominios/${cid}/flujo-caja`, { params: { desde, hasta } })
      .then((r) => setData(r.data))
      .catch((e) => setError(e.response?.data?.error || e.message));
  };

  useEffect(() => {
    if (cid) {
      localStorage.setItem('gc_condominio_id', cid);
      load();
    }
  }, [cid]);

  return (
    <>
      <div className="page-header">
        <h2>Flujo de caja</h2>
        <p>Movimientos de la cuenta default del condominio.</p>
      </div>
      {error && <div className="alert alert-error">{error}</div>}

      <div className="card">
        <div className="form-row">
          <div className="field">
            <label>Desde</label>
            <input type="date" value={desde} onChange={(e) => setDesde(e.target.value)} />
          </div>
          <div className="field">
            <label>Hasta</label>
            <input type="date" value={hasta} onChange={(e) => setHasta(e.target.value)} />
          </div>
          <button type="button" className="btn" onClick={load}>
            Actualizar
          </button>
        </div>
      </div>

      {data && (
        <>
          <div className="stat-grid">
            <div className="stat-card">
              <span className="stat-label">Entradas</span>
              <strong>{clp(data.entradas)}</strong>
            </div>
            <div className="stat-card">
              <span className="stat-label">Salidas</span>
              <strong>{clp(data.salidas)}</strong>
            </div>
            <div className="stat-card">
              <span className="stat-label">Neto</span>
              <strong>{clp(data.neto)}</strong>
            </div>
          </div>
          <div className="card">
            <div className="table-wrap">
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th>Tipo</th>
                    <th>Dirección</th>
                    <th>Importe</th>
                    <th>Descripción</th>
                  </tr>
                </thead>
                <tbody>
                  {(data.movimientos || []).map((m) => (
                    <tr key={m._id}>
                      <td>{m.fecha ? new Date(m.fecha).toLocaleDateString('es-CL') : '—'}</td>
                      <td>{m.tipoOrigen}</td>
                      <td>{m.direccion}</td>
                      <td>{clp(m.importe)}</td>
                      <td>{m.descripcion || '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </>
  );
}
